import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { NotificationBellComponent } from './notification-bell.component';

@NgModule({
    declarations: [
        NotificationBellComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatBadgeModule,
        MatMenuModule
    ],
    exports: [
        NotificationBellComponent
    ]
})
export class NotificationBellModule { }
